import { render, staticRenderFns } from "./SubtaskActions.vue?vue&type=template&id=7476a88a&scoped=true&"
import script from "./SubtaskActions.vue?vue&type=script&lang=js&"
export * from "./SubtaskActions.vue?vue&type=script&lang=js&"
import style0 from "./SubtaskActions.vue?vue&type=style&index=0&id=7476a88a&prod&lang=css&"
import style1 from "./SubtaskActions.vue?vue&type=style&index=1&id=7476a88a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7476a88a",
  null
  
)

export default component.exports